<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="poppins fw-normal" />
    <div class="addUser">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="card">
            <div class="card-body">
              <div>
                <p class="gray-text f-18 fw-bold">Profile Picture</p>
                <section
                  :key="temp_avatar"
                  :style="{
                    backgroundImage: temp_avatar ? `url('${temp_avatar}')` : 'none',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }"
                  class="free_listing-banner d-flex align-items-center justify-content-center position-relative"
                >
                  <div class="container">
                    <div class="banner_content-wrapper">
                      <div class="banner_image__picker text-center pointer">
                        <input
                          type="file"
                          name="file-input"
                          id="file-input"
                          class="
                            file-input__input
                            position-absolute
                            overflow-hidden
                            invisible
                          "
                          @change="onFilebanner"
                          ref="banner"
                        />
                        <label
                          class="
                            file-input__label
                            d-inline-flex
                            align-items-center
                            text-white
                            pointer
                            rounded
                            grey-bg
                            py-2
                            px-3
                            f-18
                            text-dark
                          "
                          for="file-input"
                        >
                          <template v-if="!form.avatar && !temp_avatar">
                            <img src="@/assets/images/AddUser.svg" alt="Add Customer">
                            <span class="f-16 fw-400 mb-0">Upload<br>Media</span>
                          </template>
                          <template v-else>
                            <span class="f-16 fw-400 mb-0">Change Media</span>
                          </template>
                        </label>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div>
                <p class="text-start f-18 fw-bold gray-text py-3 mb-0">Customer Info</p>
              </div>
              <form ref="form" @submit.prevent="updateTheUser">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group mt-4 mt-md-0 mb-0 mb-mb-3">
                      <BreezeInput
                        id="floatingInputName"
                        type="text"
                        class="form-control input-padding fs-14 rounded-pill"
                        placeholder=""
                        aria-describedby="nameHelpInline"
                        required
                        v-model="form.first_name"
                      />
                      <BreezeLabel
                        for="floatingInputName"
                        class="gray-text fs-14 px-2"
                        value="Enter Your First Name"
                      />
                      <div v-if="$v.form.first_name.$error">
                        <div class="error" v-if="!$v.form.first_name.required">
                          First Name is Required!
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mt-4 mt-md-0 mb-0 mb-3">
                      <BreezeInput
                        id="floatingInputLastName"
                        type="text"
                        class="form-control input-padding fs-14 rounded-pill"
                        placeholder=""
                        aria-describedby="nameHelpInline"
                        required
                        v-model="form.last_name"
                      />
                      <BreezeLabel
                        for="floatingInputLastName"
                        class="gray-text fs-14 px-2"
                        value="Enter Your Last Name"
                      />
                      <div v-if="$v.form.last_name.$error">
                        <div class="error" v-if="!$v.form.last_name.required">
                          Last Name is Required!
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput
                        id="formrow-email-input"
                        type="email"
                        class="form-control fs-14 rounded-pill px-4 input-padding"
                        required
                        :disabled="user?.subscriptions?.length > 0"
                        v-model="form.email"
                        placeholder=""
                        autocomplete="email"
                      />
                      <BreezeLabel
                        for="formrow-email-input"
                        class="gray-text fs-14 px-2"
                        value="Email"
                      />
                      <div class="error" v-if="$v.form.email.$error">
                        <div class="error" v-if="!$v.form.email.required">
                          Email is Required!
                        </div>
                        <div class="error" v-if="!$v.form.email.email">
                          Please Enter Valid Email
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput
                        id="formrow-mobile-input"
                        type="number"
                        class="form-control fs-14 rounded-pill px-4 input-padding"
                        required
                        v-model="form.mobile"
                        placeholder=""
                        autocomplete="number"
                      />
                      <BreezeLabel
                        for="formrow-mobile-input"
                        class="gray-text fs-14 px-2"
                        value="Phone"
                      />
                      <div class="error" v-if="$v.form.mobile.$error">
                        <div class="error" v-if="!$v.form.mobile.required">
                          Mobile Number is Required!
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput
                        type="text"
                        class="form-control fs-14 rounded-pill px-4 input-padding"
                        v-model="address.address"
                        id="address-field-address"
                        placeholder=""
                      />
                      <BreezeLabel
                        class="gray-text fs-14 px-2"
                        for="address-field-address"
                      >
                        Address
                      </BreezeLabel>
                      <div class="error" v-if="$v.address.address.$error">
                        <div class="error" v-if="!$v.address.address.required">
                          Address is Required!
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput
                        id="address-field-city"
                        type="text"
                        class="form-control fs-14 rounded-pill px-4 input-padding"
                        required
                        v-model="address.city"
                        placeholder=""
                        autocomplete="number"
                      />
                      <BreezeLabel
                        for="address-field-city"
                        class="gray-text fs-14 px-2"
                        value="City/Town"
                      />
                      <div class="error" v-if="$v.address.city.$error">
                        <div class="error" v-if="!$v.address.city.required">
                          City/Town is Required.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3 form-group">
                      <select
                        class="form-select border-radius-24 fs-14 mb-4 gray-text"
                        aria-label="Country"
                        required
                        v-model="address.country"
                      >
                        <option value="" disabled>Country*</option>
                        <option
                          v-for="(name, code) in countries"
                          :key="code"
                          :value="code"
                        >
                          {{ name }}
                        </option>
                      </select>
                      <div class="error" v-if="$v.address.country.$error">
                        <div class="error" v-if="!$v.address.country.required">
                          Country is Required.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput
                        id="state-id"
                        type="text"
                        class="form-control fs-14 rounded-pill px-4 input-padding"
                        required
                        v-model="address.state"
                        placeholder=""
                        autocomplete="number"
                      />
                      <BreezeLabel
                        for="state-id"
                        class="gray-text fs-14 px-2"
                        value=" State/Province"
                      />
                      <div class="error" v-if="$v.address.state.$error">
                        <div class="error" v-if="!$v.address.state.required">
                          State/Province is Required.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3 form-group">
                      <BreezeInput
                        id="zip_id"
                        type="text"
                        class="form-control fs-14 rounded-pill px-4 input-padding"
                        required
                        v-model="address.zipcode"
                        placeholder=""
                        autocomplete="number"
                      />
                      <BreezeLabel
                        for="zip_id"
                        class="gray-text fs-14 px-2"
                        value=" Zip Code"
                      />
                      <div class="error" v-if="$v.address.zipcode.$error">
                        <div class="error" v-if="!$v.address.zipcode.required">
                          Zip Code is Required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4" v-if="hasNoMembership">
                    <div class="mb-3">
                      <label for="add_membership" class="gray-text fs-14 px-2" value="add Membership">Add
                        Membership</label>
                      <input id="add_membership" type="checkbox" class="" v-model="add_membership" />
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end gap-3"> 
                  <div class="cta_submit button text-end border-orange fit-content rounded-pill p1 float-end">
                    <SubmitButton
                      :processing="processing"
                      type="submit"
                      class="btn btn-primary waves-effect waves-light w-md"
                      text="Update User"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import BreezeInput from "@/components/Input/input";
import BreezeLabel from "@/components/Input/label";

export default {
  page: {
    title: "Update User",
    meta: [
      {
        name: "update-user",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BreezeInput,
    BreezeLabel
  },
  computed: {
    hasNoMembership() {
       if(this.user?.subscriptions?.length === 0){
        return true;
      }

      if(this.user?.subscriptions?.every(subscription => subscription.stripe_status === 'canceled')){
        return true;
      }

      return false;
    }
  },

  data() {
    return {
      countries: [],
      processing: false,
      temp_avatar: null,
      isFree: false,
      isAdmin: false,
      form: {
        id: this.$route.params.id,
        avatar: null,
        first_name: null,
        last_name: null,
        email: null,
        mobile: null,
      },
      address: {
        address: "",
        city: "",
        country: "",
        state: "",
        zipcode: "",
      },
      user: {},
      title: "Update User",
      items: [
        {
          text: "Omaha",
        },
        {
          text: "Update User",
          active: true,
        },
      ],
      add_membership:false
    };
  },
  validations: {
    form: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      email: {
        email,
        required,
      },
      mobile: {
        required,
      },
    },
    address: {
      address: {
        required,
      },
      city: {
        required,
      },
      country: {
        required,
      },
      state: {
        required,
      },
      zipcode: {
        required,
      },
    },
  },
  mounted() {
    if (this.$route.query.free === "true" || this.$route.query.free === true) {
      this.isFree = true;
    }
    if (this.$route.query.admin === "true" || this.$route.query.admin === true) {
      this.isAdmin = true;
    }
    this.getCountries();
    this.singleUserRecord();
  },
  methods: {
    onFilebanner(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.form.avatar = this.$refs.banner.files[0];
      this.temp_avatar = URL.createObjectURL(file);
    },
    getCountries() {
      this.$axios
        .get("countries")
        .then((response) => {
          this.countries = response?.data?.data;
        })
        .catch((error) => {
          console.error("Error fetching countries:", error);
        });
    },
    singleUserRecord() {
      this.$axios
        .get("single-user-record/" + this.form.id,{params:{ with_subscriptions: true }})
        .then((response) => {
          this.user = response.data.data;
          this.form.first_name = this.user.first_name;
          this.form.last_name = this.user.last_name;
          this.form.email = this.user.email;
          this.form.mobile = this.user.mobile;
          let addr = this.user.address;
          if (typeof addr === "string") {
            try {
              addr = JSON.parse(addr);
            } catch (e) {
              addr = {};
            }
          }
          if (addr && typeof addr === "object") {
            this.address.address = addr.address || "";
            this.address.city = addr.city || "";
            this.address.country = addr.country || "";
            this.address.state = addr.state || "";
            this.address.zipcode = addr.zipcode || "";
          }
          this.temp_avatar = this.user.avatar_url || this.user.avatar || this.temp_avatar;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    updateTheUser() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.processing = true;
      const formData = new FormData();
      formData.append("id", this.form.id);
      if (this.form.avatar) {
        formData.append("avatar", this.form.avatar);
      }
      if (this.isFree && !this.isAdmin) {
        formData.append("is_free_member", 1);
      }
      if (this.isAdmin) {
        formData.append("is_admin", 1);
      }
      formData.append("first_name", this.form.first_name || "");
      formData.append("last_name", this.form.last_name || "");

      if (!this.user?.subscriptions?.length > 0) {
        formData.append("email", this.form.email || "");
      }else {
        formData.append("email", this.user.email || "");
      }
      formData.append("mobile", this.form.mobile || "");
      formData.append("address", JSON.stringify(this.address));
      this.$axios
        .post("update-user-data", formData)
        .then((response) => {
          this.triggerSwal("Record updated successfully", "success");
          if (this.isFree) {
            this.$router.push({ path: "/FreeUsers/Listing" });
            this.isFree = false;
          } 
          else if (this.isAdmin) {
            this.$router.push({
              path: "/AdminUsers/Listing",
            });
            this.isAdmin = false;
          } 
          else {
            this.$router.push({
              name: "user-listing",
              query: { currentPage: this.$route.query.currentPage },
            });
          }
          this.processing = false;
        })
        .catch((error) => {
          this.handleErrorResponse(error.response, "error");
          this.processing = false;
        });
    },
  },
};
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
